import React from 'react'
import {useBasketStore, useCustomerStore, useRapidDeliveryStore} from '../../../store/hooks/useStore'
import {Box, Flex, Text} from '../../../vanilla'
import {ChevronRightIcon, DeliverySmallIcon, LocationIcon, RapidThumbIcon} from '../../icons'
import {Link} from '../../link'
import {ReservationDetails} from './mobile-navigation-booking/reservation-details'
import {ReservationExpiredSlot} from './mobile-navigation-booking/reservation-expired-slot'
import {observer} from 'mobx-react'
import DeliveryInitial from './mobile-navigation-booking/delivery-initial'
import { useSlotExpiration } from '../../../store/hooks/useSlotExpiration'
import { MobileNavigationLoggedLinksProps } from './mobile-navigation-logged-links'
import SlotsErrorMessaging from '../../../pages/book-delivery/partials/booking-slots/error-messaging'
import { DeliveryTimeAndDate } from '../../book-delivery/delivery-time-and-date'
import { RapidDeliveryETA } from '../../book-delivery/rapid-delivery-eta'

export const DeliverySlot = observer(({onClose}: MobileNavigationLoggedLinksProps) => {
  const {
    basket,
    currentDeliverySlotId,
    slotTime,
    addressDisplay,
    postcodeError,
    setPostcodeError
  } = useBasketStore()
  const {isRapidDeliveryBooked} = useRapidDeliveryStore()
  const {isRegistered} = useCustomerStore()

  const {isReservationExpired} = useSlotExpiration()

  if (postcodeError) {
    return <SlotsErrorMessaging variant='mobileNav' buttonAction={() => { setPostcodeError?.(false) }} />
  }

  return (
    <Box paddingX="12px">
      {currentDeliverySlotId && (
        <Text variant="text3Bold" lineHeight="short" marginBottom="8px">
          {isRapidDeliveryBooked ? 'Your Rapid Delivery' : 'Your Delivery'}
        </Text>
      )}
      <Box
        padding="12px"
        bg="white"
        border="1px"
        borderColor="gray200"
        borderRadius="medium"
        position="relative"
      >
        <Flex gap="8px" align="center">
          {isRapidDeliveryBooked ? (
            <RapidThumbIcon boxSize="36px" />
          ) : (
            <DeliverySmallIcon color="accent0" boxSize="44px" />
          )}

          {currentDeliverySlotId ? (
            <Flex justify="space-between" align="center" width="full" as={Link} to="/select-delivery" onClick={onClose}>
              {isRapidDeliveryBooked ? (
                <RapidDeliveryETA isBasket compact />
              ) : (
                <DeliveryTimeAndDate
                  startHour={slotTime(basket?.c_windowStartTime)}
                  endHour={slotTime(basket?.c_windowEndTime)}
                  textProps={{fontSize: 'xs', lineHeight: 'shorter'}}
                  dateTextProps={{fontSize: 'xs', lineHeight: 'shorter', color: 'gray700'}}
                  showDate
                  dateFormat="EEEE do MMMM"
                />
              )}
              <ChevronRightIcon width="16px" height="auto" color="gray800" flexShrink="0" />
            </Flex>
          ) : (
            <Box flexGrow="1">
              <DeliveryInitial onClose={onClose} />
            </Box>
          )}
        </Flex>

        {currentDeliverySlotId && (
          isReservationExpired() ? <ReservationExpiredSlot /> : <ReservationDetails />
        )}

        {!currentDeliverySlotId && isRegistered && addressDisplay && (
          <Flex gap="8px" align="center" marginTop="8px">
            <LocationIcon width="16px" height="auto" color="accent1" flexShrink="0" />
            <Text
              as={Link}
              to="/select-delivery"
              onClick={onClose}
              variant="text2"
              color="accent1"
              textDecoration="underline"
              data-test-selector="delivery-address-link"
              data-cs-mask=""
            >
              {addressDisplay}
            </Text>
          </Flex>
        )}
      </Box>
    </Box>
  )
})
